import { useI18n } from 'vue-i18n';
import { createVueI18nAdapter } from 'vuetify/locale/adapters/vue-i18n';
import { createVuetify } from 'vuetify';
import { VBtn, VAlert } from 'vuetify/components';


const colors = {
  primary: '#1976D2',
  secondary: '#585858',
  accent: '#82B1FF',
  error: '#E13E3E',
  info: '#2196F3',
  success: '#4CAF50',
  warning: '#FFC107',
};

export default defineNuxtPlugin((app) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const i18n: any = { global: app.$i18n };
  const vuetify = createVuetify({
    aliases: {
      VAlertError: VAlert,
      VAlertWarning: VAlert,
      VAlertSuccess: VAlert,
      VAlertInfo: VAlert,
      VBtnAccount: VBtn,
      VBtnCancel: VBtn,
      VBtnClose: VBtn,
      VBtnClosePrimary: VBtn,
      VBtnSuccess: VBtn,
      VBtnPrimary: VBtn,
      VBtnSecondary: VBtn,
      VBtnAdd: VBtn,
      VBtnTableIconAdd: VBtn,
      VBtnTableIconDelete: VBtn,
      VBtnSnackbar: VBtn,
      VBtnTableIconEdit: VBtn,
      VBtnTableIconFilter: VBtn,
      VBtnTableIconDownload: VBtn,
      VBtnTableIconInvite: VBtn,
    },
    defaults: {
      VAlertError: {
        density: 'comfortable',
        color: 'error',
        closable: true,
        icon: 'mdi-close-octagon',
      },
      VAlertWarning: {
        density: 'comfortable',
        color: 'warning',
        closable: true,
        icon: 'mdi-alert',
      },
      VAlertSuccess: {
        density: 'comfortable',
        color: 'success',
        closable: true,
        icon: 'mdi-check',
      },
      VAlertInfo: {
        density: 'comfortable',
        color: 'info',
        closable: true,
        icon: 'mdi-information',
      },
      VBtnPrimary: {
        color: 'primary',
      },
      VBtnSecondary: {
        color: 'secondary',
      },
      VBtnSuccess: {
        color: 'success',
      },
      VBtnClose: {
        color: 'secondary',
        variant: 'text',
      },
      VBtnClosePrimary: {
        color: 'primary',
        variant: 'text',
      },
      VBtnAdd: {
        color: 'primary',
        prependIcon: 'mdi-plus',
      },
      VBtnCancel: {
        color: 'secondary',
        variant: 'text',
      },
      VBtnSnackbar: {
        color: 'white',
        variant: 'text',
      },
      VBtnAccount: {
        density: 'comfortable',
        color: 'secondary',
        class: 'text-caption',
        variant: 'elevated',
      },
      VSelect: {
        variant: 'underlined',
      },
      VToolbar: {
        VBtn: { variant: 'text' },
      },
      VTextField: { variant: 'underlined' },
      VDataTable: {
        class: 'rounded elevation-2',
      },
      VDataTableServer: {
        class: 'rounded elevation-2',
        density: 'comfortable',
        headers: {
          class: 'text-primary',
        },
      },
      VBtnTableIconAdd: {
        variant: 'text',
        icon: 'mdi-plus',
        color: 'success',
      },
      VBtnTableIconDelete: {
        variant: 'text',
        icon: 'mdi-delete',
        color: 'error',
      },
      VBtnTableIconFilter: {
        variant: 'text',
        icon: 'mdi-filter',
        color: 'primary',
      },
      VBtnTableIconEdit: {
        variant: 'text',
        icon: 'mdi-pencil',
        color: 'primary',
      },
      VBtnTableIconDownload: {
        variant: 'text',
        icon: 'mdi-download',
        color: 'primary',
      },
      VBtnTableIconInvite: {
        variant: 'text',
        icon: 'mdi-email-fast-outline',
        color: 'primary',
      },
    },
    locale: {
      adapter: createVueI18nAdapter({ i18n, useI18n }),
    },
    theme: {
      defaultTheme: 'light',
      themes: {
        dark: {
          dark: true,
          colors,
        },
        light: {
          dark: false,
          colors: {
            ...colors,
            background: '#EEEEEE',
          },
        },
      },
    },
  });

  app.vueApp.use(vuetify);
});
